import {
    FETCH_MIDDLE_PANEL_DATA_REQUEST,
    FETCH_MIDDLE_PANEL_FILTER_REQUEST,
    FETCH_MIDDLE_PANEL_NOTES_REQUEST,

    UPDATE_MIDDLE_PANEL_NOTES_REQUEST,

    FETCH_MIDDLE_PANEL_FILE_REQUEST,
    FETCH_MIDDLE_PANEL_DIARIES_REQUEST,
    FETCH_MIDDLE_PANEL_LOG_REQUEST,

    UPDATE_MIDDLE_PANEL_LOG_REQUEST,

    FETCH_MIDDLE_PANEL_PARTIES_REQUEST,
    CHANGE_ACTIVITY_RESOLUTION_REQUEST,
    WRITE_NOTE_REVIEW_REQUEST,
    RESET_MIDDLE_PANEL_INITIAL_STATE_REQUEST,
    UPDATE_CAPTION,
    UPDATE_ACTIVITY_FIELD,
    RESET_MIDDLE_PANEL_INDIVIDUAL_TAB,
    WORKKARD_TODO_OWNERS_REQUEST,
    DIARIES_TITLE_EDIT_REQUEST,
    DIARIES_DUE_DATE_EDIT_REQUEST,
    DIARIES_ACTION_COMPLETE_REQUEST,
    DIARIES_ACTION_CANCELLED_REQUEST,
    IS_LARGE_VIEW_ACTIVE,
    IS_SELECT_ALL,
    NOTES_UPDATE_FILE_CAPTION,
    DELETE_ASSOCIATED_PARTY_REQUEST,
    DELETE_ASSOCIATED_PARTY_REQUEST_SUCCESS,
    FETCH_REOPEN_REASON_LIST,
   UPDATE_ACTIVITY_EXCLUDED_FILTER,
    RESET_POST_API_ACTION_ERROR_REQUEST
  } from "../../../containers/WorkkardDetail/actions/actionConstants";

  export const fetchMiddlePanelData = payload => ({
    type: FETCH_MIDDLE_PANEL_DATA_REQUEST,
    payload
  });

  export const fetchMiddlePanelFilterData = payload => ({
    type: FETCH_MIDDLE_PANEL_FILTER_REQUEST,
    payload
  });

  export const fetchMiddlePanelNotesData = payload => ({
    type: FETCH_MIDDLE_PANEL_NOTES_REQUEST,
    payload
  });

  export const fetchMiddlePanelFilesData = payload => ({
    type: FETCH_MIDDLE_PANEL_FILE_REQUEST,
    payload
  });

  export const fetchMiddlePanelDiariesData = payload => ({
    type: FETCH_MIDDLE_PANEL_DIARIES_REQUEST,
    payload
  });

  export const fetchMiddlePanelLogsData = payload => ({
    type: FETCH_MIDDLE_PANEL_LOG_REQUEST,
    payload
  });


  export const fetchMiddlePanelPartiesData = payload => ({
    type: FETCH_MIDDLE_PANEL_PARTIES_REQUEST,
    payload
  });
  

  // export const getCloseActPermission = payload => ({
  //   type: GET_CLOSE_ACT_PERMISSION,
  //   payload
  // });

  export const changeActivityResolution = payload => ({
    type: CHANGE_ACTIVITY_RESOLUTION_REQUEST,
    payload
  });

  export const writeNoteReview = payload => ({
    type: WRITE_NOTE_REVIEW_REQUEST,
    payload
  });


  export const resetMiddlePanelInitialState = () => ({
    type: RESET_MIDDLE_PANEL_INITIAL_STATE_REQUEST,
  });

  export const fetchReOpenReasonList = (payload) => ({
    type: FETCH_REOPEN_REASON_LIST,
    payload
  });

  export const updateFileCaption= payload =>({
    type:UPDATE_CAPTION,
    payload
  })

  export const updateActivityField= payload =>({
    type:UPDATE_ACTIVITY_FIELD,
    payload
  })

export const resetMiddlePanel = payload => ({
  type: RESET_MIDDLE_PANEL_INDIVIDUAL_TAB,
  payload
});
export const updateExcludedFilters = payload => ({
  type: UPDATE_ACTIVITY_EXCLUDED_FILTER,
  payload
});

  export const fetchWorkkardTodoOwners  = payload => ({
    type: WORKKARD_TODO_OWNERS_REQUEST,
    payload
  });

  export const changeDiarieTitle  = payload => ({
    type: DIARIES_TITLE_EDIT_REQUEST,
    payload
  })

  export const changeDiarieDueDate  = payload => ({
    type: DIARIES_DUE_DATE_EDIT_REQUEST,
    payload
  })

  export const changeDiarieActionComplete  = payload => ({
    type: DIARIES_ACTION_COMPLETE_REQUEST,
    payload
  })

  export const changeDiarieActionCancelled  = payload => ({
    type: DIARIES_ACTION_CANCELLED_REQUEST,
    payload
  })

  export const toggleFileView  = payload =>({
    type:IS_LARGE_VIEW_ACTIVE,
    payload
  })

  export const toggleSelectAll  = payload => ({
    type:IS_SELECT_ALL,
    payload
  })

  export const updateNotesFileCaption=payload=>({
    type:NOTES_UPDATE_FILE_CAPTION,
    payload
  })

  export const updateMiddlePanelNotesData = payload => ({
    type: UPDATE_MIDDLE_PANEL_NOTES_REQUEST,
    payload
  });

  export const updateMiddlePanelLogsData= payload =>({
    type:UPDATE_MIDDLE_PANEL_LOG_REQUEST,
    payload
  });

  export const deleteAssociatedParty = payload => ({
    type: DELETE_ASSOCIATED_PARTY_REQUEST,
    payload
  })

  export const deleteAssociatedPartySucess = payload => ({
    type: DELETE_ASSOCIATED_PARTY_REQUEST_SUCCESS,
    payload
  })

  export const resetPostApiActionError = () => ({
    type: RESET_POST_API_ACTION_ERROR_REQUEST,
  });